import { createAsyncThunk } from "@reduxjs/toolkit";
import { ThunkApi } from "../store.ts";
import {
  DataCollectionApi,
  EmploymentStatusRequestEmploymentStatusEnum,
  IncomeMonthlyRequest,
} from "../../orchestrator-api-client";
import { LayoutError } from "../slices/layout/types/layout-error.ts";
import { pushErrorMonitor } from "../../features/analytics/analytics.service.ts";

export interface SubmitIncomePayload extends IncomeMonthlyRequest {
  employmentStatus: string;
}

export const submitIncome = createAsyncThunk<
  SubmitIncomePayload,
  IncomeMonthlyRequest,
  ThunkApi
>("submitIncome", async (incomeData, { rejectWithValue, getState }) => {
  const employmentStatus = getState().customer.job.employmentStatus; //TODO: Remove after Websocket implementation

  try {
    if (
      employmentStatus === EmploymentStatusRequestEmploymentStatusEnum.Pensioner
    ) {
      await new DataCollectionApi().addPensionerIncome(incomeData);
    } else {
      await new DataCollectionApi().addIncome(incomeData);
    }

    return { ...incomeData, employmentStatus };
  } catch (err: any) {
    pushErrorMonitor(err); //send error push monitor
    const error: LayoutError = {
      title: "Salvataggio entrate",
      description:
        "Non siamo riusciti a salvare le tue entrate.\n Puoi riprovare o contattare il supporto",
      error: err.message,
    };
    return rejectWithValue(error);
  }
});
